import React, { Component } from 'react';
import styled from 'styled-components';

import List from '../../common/components/List';
import colors from '../../../utils/colors';
import Icon from '../../../icons/Icon';
import {media} from '../../../utils/uiSizes';
import { rem } from 'polished';

const StyledProductCard = styled.div`
  background: white;
  box-sizing: border-box;
  padding: 1.25rem 1.25rem 2.5rem;
  border-radius: 0.625rem;
  border-top: 1.25rem solid ${colors.BRAND_RED_DARK};
  margin-top: 1.25rem;
  display: flex;
  flex-direction: column;
  width: 100%;

  ${media.tablet`
    margin-top: 1rem;
  `}
  ${media.desktop`
    width: auto;
  `}

  ${props => props.borderColor && `
    border-color: ${props.borderColor};
  `}

  h3 {
    font-family: FyranSans-Core;
    font-size: 1.375rem;
    font-weight:400;
    ${props => props.borderColor && `
    color: ${props.borderColor};
    `}
    margin-bottom: 1.25rem;
  }

  dt {
    font-size:${rem('18px')};
    margin-bottom: .25rem;
    position: relative;
    padding-left: 1.75rem;
    ${media.desktop`
      padding-left: 1.66rem;
    `}
    svg {
      fill: ${colors.GRAY_MIDDLE};
      stroke: none;
      position: absolute;
      left: -.125rem;
      top: -.125rem;
    }
  }

  dd {
    font-size:${rem('15px')};
    font-weight:400;
    line-height: 1.25em;
    color: ${colors.GRAY};
    margin-bottom: 0.5rem;
    padding-left: 1.75rem;
    ${media.tablet`
      margin-bottom: 1rem;
    `}
    ${media.desktop`
      padding-left: 1.66rem;
    `}
  }

  footer {
    text-align: center;
    margin-top: auto;
    padding-top: 1rem;
    color: ${colors.GRAY};
    p {
      font-size:${rem('12px')};
      line-height: ${rem('15px')};
      font-weight:400;
    }

    a {
      display: block;
      margin-top: 1rem;
    }
  }
`;

class ProductCategoryCard extends Component {

  renderDescription = (item) => {
    const {
      _id,
      title,
      description,
    } = item;

    return (
      <div key={_id}>
        <dt><Icon icon="#checkmark" /><span>{title}</span></dt>
        <dd>{description}</dd>
      </div>
    );
  }

  render() {
    const { name, description, descriptions, url, settings } = this.props.productCategory;

    return (
      <StyledProductCard borderColor={settings.color}>
        <header>
          <h3>{name}</h3>
        </header>
        <List
          Container='dl'
          items={descriptions}
          renderItem={this.renderDescription}
        />
        <footer>
          <p>{description}</p>
          {url && (
            <a href={url}>Lisätietoja</a>
          )}
        </footer>
      </StyledProductCard>
    );
  }
};

export default ProductCategoryCard;


// WEBPACK FOOTER //
// ./src/modules/product-category/components/ProductCategoryCard.js